// extracted by mini-css-extract-plugin
export default {"menuBlock":"nG-z","title":"oG-z","nav":"pG-z","flexCell":"qG-z","facetLink":"rG-z"};